export * from './types';
var BaseAppEssentials = /** @class */ (function () {
    function BaseAppEssentials(_env, _essentials) {
    }
    return BaseAppEssentials;
}());
export { BaseAppEssentials };
var BasePlatformEssentials = /** @class */ (function () {
    function BasePlatformEssentials(_env, experiments) {
        this.experiments = experiments;
        this.metaSiteId = _env.metaSiteId;
    }
    return BasePlatformEssentials;
}());
export { BasePlatformEssentials };
//# sourceMappingURL=api.js.map